export enum CLICKFROM {
  LEGEND = 'legend',
  PART = 'part',
  NONE = 'none'
}

export enum STATUSTYPE {
  HIGHLIGHT = 'highlight',
  DETAIL = 'detail',
  DEFAULT = 'default'
}

export type SelectValue = {
  source: CLICKFROM;
  callout: number;
  partNo: string;
  type: STATUSTYPE;
  isDefault?: boolean;
};

export const InitSelectValue: SelectValue = {
  callout: 0,
  partNo: '',
  source: CLICKFROM.NONE,
  type: STATUSTYPE.DEFAULT,
  isDefault: false
};
